import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'product-requirements.field-1-name': {
    id: 'product-requirements.field-1-name',
    defaultMessage: 'User story',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: User story',
  },
  'product-requirements.field-2-name': {
    id: 'product-requirements.field-2-name',
    defaultMessage: 'Description',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Description',
  },
  'product-requirements.field-3-name': {
    id: 'product-requirements.field-3-name',
    defaultMessage: 'Asset file',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Asset file',
  },
  'product-requirements.field-4-name': {
    id: 'product-requirements.field-4-name',
    defaultMessage: 'Priority',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Priority',
  },
  'product-requirements.field-4-select-option-1': {
    id: 'product-requirements.field-4-select-option-1',
    defaultMessage: 'High',
    description:
      'The option value for option #1 in field #4 for this database template. In this case: High',
  },
  'product-requirements.field-4-select-option-2': {
    id: 'product-requirements.field-4-select-option-2',
    defaultMessage: 'Medium',
    description:
      'The option value for option #2 in field #4 for this database template. In this case: Medium',
  },
  'product-requirements.field-4-select-option-3': {
    id: 'product-requirements.field-4-select-option-3',
    defaultMessage: 'Low',
    description:
      'The option value for option #3 in field #4 for this database template. In this case: Low',
  },
  'product-requirements.field-5-name': {
    id: 'product-requirements.field-5-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Status',
  },
  'product-requirements.field-5-select-option-1': {
    id: 'product-requirements.field-5-select-option-1',
    defaultMessage: 'To do',
    description:
      'The option value for option #1 in field #5 for this database template. In this case: To do',
  },
  'product-requirements.field-5-select-option-2': {
    id: 'product-requirements.field-5-select-option-2',
    defaultMessage: 'In progress',
    description:
      'The option value for option #2 in field #5 for this database template. In this case: In progress',
  },
  'product-requirements.field-5-select-option-3': {
    id: 'product-requirements.field-5-select-option-3',
    defaultMessage: 'Complete',
    description:
      'The option value for option #3 in field #5 for this database template. In this case: Complete',
  },
  'product-requirements.field-6-name': {
    id: 'product-requirements.field-6-name',
    defaultMessage: 'Launch date',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Launch date',
  },
  'product-requirements.view-1-name': {
    id: 'product-requirements.view-1-name',
    defaultMessage: 'All requirements',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All requirements',
  },
  'product-requirements.entry-1-cell-1': {
    id: 'product-requirements.entry-1-cell-1',
    defaultMessage: 'As a user, I want to be able to create a database.',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  As a user, I want to be able to create a database.',
  },
  'product-requirements.entry-1-cell-2': {
    id: 'product-requirements.entry-1-cell-2',
    defaultMessage:
      'Create databases inline in pages or from global and contextual create.',
    description:
      'The text value of cell #2 in row (entry) #1 in this database template. In this case:  Create databases inline in pages or from global and contextual create.',
  },
  'product-requirements.entry-2-cell-1': {
    id: 'product-requirements.entry-2-cell-1',
    defaultMessage: 'As a user, I want to change the layout of my database.',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  As a user, I want to change the layout of my database.',
  },
  'product-requirements.entry-2-cell-2': {
    id: 'product-requirements.entry-2-cell-2',
    defaultMessage: 'Switch between table, card, and board layouts easily.',
    description:
      'The text value of cell #2 in row (entry) #2 in this database template. In this case:  Switch between table, card, and board layouts easily.',
  },
  'product-requirements.entry-3-cell-1': {
    id: 'product-requirements.entry-3-cell-1',
    defaultMessage: 'As a user, I want to connect and import Jira issues in a database.',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  As a user, I want to connect and import Jira issues in a database.',
  },
  'product-requirements.entry-3-cell-2': {
    id: 'product-requirements.entry-3-cell-2',
    defaultMessage: 'Bulk add Jira issues and keep the info synced and up-to-date.',
    description:
      'The text value of cell #2 in row (entry) #3 in this database template. In this case:  Bulk add Jira issues and keep the info synced and up-to-date.',
  },
});
